module.exports = __webpack_public_path__ + "static/media/login-background.233205a3.png";